var map = {
	"./Christina Perri feat. Steve Kazee - A Thousand Years (Part 2).mp3": 8451,
	"./a-gentle-breeze-189206.mp3": 4501,
	"./my-love_short-177579.mp3": 9172,
	"./peaceful-sleep-188311.mp3": 7567
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9517;